import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

interface SafetyResult {
  safe: boolean;
  threatType?: string;
  finalUrl?: string;
}

export const validateUrlSafety = async (url: string): Promise<SafetyResult> => {
  const validate = httpsCallable<{ url: string }, SafetyResult>(functions, 'validateUrl');
  const result = await validate({ url });
  return result.data;
};
